import { apiClient } from "./axios";

const productList = async ({ page }) => {
  try {
    const res = await apiClient.get(
      `/api/v1/product/list?page=${page}`
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return {
      data: res.data,
    };
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const productBannerList = async ({ limit, location }) => {
  try {
    const res = await apiClient.get(
      `/api/v1/product/banner/list?limit=${limit}&location=${location}`
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return {
      data: res.data,
    };
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const productHooks = {
  productList,
  productBannerList,
};

export default productHooks;
